import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import BrowserOnly from 'components/consumer/BrowserOnly';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPDesktopPhotoPanel from '../PDPDesktopPhotoPanel';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPAvailableInSizes from '../PDPAvailableInSizes';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPCompleteOrder from '../PDPCompleteOrder';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPSellingAttributes from '../PDPSellingAttributes';
import PDPProductDescription from '../PDPProductDescription';
import PDPDimensionsAndDetails from '../PDPDimensionsAndDetails';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPDesktopPlaceholder from '../PDPDesktopPlaceholder';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const ModularAddProductsMarxent = loadable(() => import('components/consumer/modular-configurator/ModularAddProducts/marxent'));
const PDPDesktopInner = t0 => {
  const $ = _c(63);
  const {
    discontinuedCategoryMsg: t1,
    pdpIsModularBYOProduct: t2,
    isEditOrder,
    isEFGInternal: t3,
    isOutOfStock: t4,
    showDiscontinuedNotification: t5,
    showOutOfStockNotification: t6,
    slug,
    productHeroImage: t7,
    productCylindoHeroImage: t8
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const isEFGInternal = t3 === undefined ? false : t3;
  const isOutOfStock = t4 === undefined ? false : t4;
  const showDiscontinuedNotification = t5 === undefined ? false : t5;
  let t9;
  if ($[0] !== t6) {
    t9 = t6 === undefined ? {} : t6;
    $[0] = t6;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const showOutOfStockNotification = t9;
  const productHeroImage = t7 === undefined ? null : t7;
  const productCylindoHeroImage = t8 === undefined ? null : t8;
  const isBrowser = useIsBrowser();
  const [efgInternalKey, setEfgInternalKey] = useState("0");
  const [displayPressComp, setDisplayPressComp] = useState(false);
  const [marxentSelectedFabric, setMarxentSelectedFabric] = useState(null);
  const [hideMarxent, setHideMarxent] = useState(true);
  const [unavailableFabric, setUnavailableFabric] = useState(false);
  let t10;
  let t11;
  if ($[2] !== isEFGInternal) {
    t10 = () => {
      if (isEFGInternal && !isNewConsumerApp) {
        setEfgInternalKey("1");
      }
    };
    t11 = [isEFGInternal];
    $[2] = isEFGInternal;
    $[3] = t10;
    $[4] = t11;
  } else {
    t10 = $[3];
    t11 = $[4];
  }
  useEffect(t10, t11);
  let t12;
  if ($[5] !== isEditOrder) {
    t12 = <PDPNameSection isEditOrder={isEditOrder} />;
    $[5] = isEditOrder;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  let t13;
  if ($[7] !== isBrowser || $[8] !== isEditOrder) {
    t13 = !isEditOrder && (!isNewConsumerApp || isBrowser) ? <PDPAvailableInSizes /> : <div className="PDPDesktop__PDPAvailableInSizes-filler" />;
    $[7] = isBrowser;
    $[8] = isEditOrder;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <PDPOnDisplayInShowroom />;
    $[10] = t14;
  } else {
    t14 = $[10];
  }
  let t15;
  if ($[11] !== discontinuedCategoryMsg || $[12] !== showDiscontinuedNotification) {
    t15 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPDesktop__PDPAlertBar-filler" />;
    $[11] = discontinuedCategoryMsg;
    $[12] = showDiscontinuedNotification;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== isEditOrder || $[15] !== isOutOfStock || $[16] !== marxentSelectedFabric || $[17] !== pdpIsModularBYOProduct || $[18] !== showDiscontinuedNotification || $[19] !== slug || $[20] !== unavailableFabric) {
    t16 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPDesktop__in-stock-options">{pdpIsModularBYOProduct && <BrowserOnly><div className="border-t border-gray-light7"><SuspenseWithLoader><ModularAddProductsMarxent marxentSelectedFabric={marxentSelectedFabric} unavailableFabric={unavailableFabric} setHideMarxent={setHideMarxent} setUnavailableFabric={setUnavailableFabric} key={slug} /></SuspenseWithLoader></div></BrowserOnly>}<PDPShopTabsBar isEditOrder={isEditOrder} /><PDPChooseYourOptions isEditOrder={isEditOrder} setMarxentSelectedFabric={setMarxentSelectedFabric} />{!isEditOrder && <PDPUpSellProduct />}{!isEditOrder && !pdpIsModularBYOProduct && <PDPProtectionPlanSelector />}</div> : <div className="PDPDesktop__in-stock-options-filler" />;
    $[14] = isEditOrder;
    $[15] = isOutOfStock;
    $[16] = marxentSelectedFabric;
    $[17] = pdpIsModularBYOProduct;
    $[18] = showDiscontinuedNotification;
    $[19] = slug;
    $[20] = unavailableFabric;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== isOutOfStock || $[23] !== showDiscontinuedNotification || $[24] !== showOutOfStockNotification) {
    t17 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPDesktop__PDPAlertSection-filler" />;
    $[22] = isOutOfStock;
    $[23] = showDiscontinuedNotification;
    $[24] = showOutOfStockNotification;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== isEditOrder || $[27] !== isOutOfStock) {
    t18 = isEditOrder ? <PDPCompleteOrder /> : <PDPAddToBagSection isOutOfStock={isOutOfStock} isEditOrder={isEditOrder} />;
    $[26] = isEditOrder;
    $[27] = isOutOfStock;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <PDPSellingAttributes />;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== isEditOrder) {
    t20 = !isEditOrder ? <PDPProductDescription /> : <div className="PDPDesktop__PDPProductDescription-filler" />;
    $[30] = isEditOrder;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== pdpIsModularBYOProduct) {
    t21 = !pdpIsModularBYOProduct ? <PDPDimensionsAndDetails /> : <div className="PDPDesktop__PDPDimensionsAndDetails-filler" />;
    $[32] = pdpIsModularBYOProduct;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== isEditOrder || $[35] !== slug) {
    t22 = !isEditOrder ? <PDPCustomerPhotos slug={slug} /> : <div className="PDPDesktop__PDPCustomerPhotos-filler" />;
    $[34] = isEditOrder;
    $[35] = slug;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== displayPressComp) {
    t23 = !displayPressComp ? <SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} /></SuspenseWithLoader> : <div className="PDPDesktop__PDPPress-filler" />;
    $[37] = displayPressComp;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== efgInternalKey || $[40] !== t12 || $[41] !== t13 || $[42] !== t15 || $[43] !== t16 || $[44] !== t17 || $[45] !== t18 || $[46] !== t20 || $[47] !== t21 || $[48] !== t22 || $[49] !== t23) {
    t24 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]" key={efgInternalKey}>{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}</div>;
    $[39] = efgInternalKey;
    $[40] = t12;
    $[41] = t13;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <PDPBreadCrumbs />;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== hideMarxent || $[53] !== isEditOrder || $[54] !== pdpIsModularBYOProduct || $[55] !== productCylindoHeroImage || $[56] !== productHeroImage || $[57] !== slug || $[58] !== unavailableFabric) {
    t26 = <div className="flex-1 mr-12">{t25}<PDPDesktopPhotoPanel slug={slug} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} /></div>;
    $[52] = hideMarxent;
    $[53] = isEditOrder;
    $[54] = pdpIsModularBYOProduct;
    $[55] = productCylindoHeroImage;
    $[56] = productHeroImage;
    $[57] = slug;
    $[58] = unavailableFabric;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t24 || $[61] !== t26) {
    t27 = <FixedWidthContainer wide={true} className="flex flex-row-reverse !pt-2 !pb-8 max-[1023px]:hidden" data-xc="PDPDesktop">{t24}{t26}</FixedWidthContainer>;
    $[60] = t24;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  return t27;
};
PDPDesktopInner.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isEditOrder: PropTypes.bool,
  isEFGInternal: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
const PDPDesktop = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPDesktopPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPDesktopInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPDesktop;